// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-textRegular-button-63512c19"};